import React from 'react'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import { Outlet } from 'react-router-dom'

const Layout = ({children}) => {
  return (
    <>
    <Header/>
    <div style={{ marginTop: '6rem' }}>
    <Outlet />
    </div>
    <Footer/>
    </>
  )
}

export default Layout